import React from "react";
import { t, businessName, itemName, customerMobile } from "./invoiceTemplate.shared";
import { InvoiceBrandMark, InvoiceSignature } from "./InvoiceBrandAssets";
import "./CompactInvoiceTemplate.css";

const CompactInvoiceTemplate = ({
  invoice,
  invoiceNumber,
  businessSnapshot,
  customerName,
  customerSnapshot,
  billingAddress,
  shippingAddress,
  calculatedItems = [],
  totals = {},
  grandTotal = 0,
  paidAmount = 0,
  balanceAmount = 0,
  displayCurrency,
  formatAddress,
  formatDate,
  formatLabel,
  formatNumber,
  numberToWords,
}) => (
  <section className="invoice-compact">
    <header className="invoice-compact__head">
      <div className="invoice-template-brand-block"><InvoiceBrandMark businessSnapshot={businessSnapshot} compact /><div><h1>{businessName(businessSnapshot)}</h1><p>{formatAddress(businessSnapshot?.address || businessSnapshot)}</p></div></div>
      <div><b>TAX INVOICE</b><strong>{invoiceNumber}</strong><span>{formatDate(invoice?.documentDate)}</span></div>
    </header>
    <div className="invoice-compact__party">
      <div><small>BILL TO</small><b>{customerName}</b><p>{formatAddress(billingAddress)}</p><span>{customerMobile(customerSnapshot, invoice)}</span></div>
      <div><small>GSTIN</small><b>{t(customerSnapshot?.gstin)}</b><small>STATUS</small><b>{formatLabel(invoice?.documentStatus)}</b></div>
    </div>
    <table><thead><tr><th>#</th><th>Item</th><th>HSN</th><th>Qty</th><th>Rate</th><th>GST</th><th>Amount</th></tr></thead>
      <tbody>{calculatedItems.map((item,index)=><tr key={item?._id || index}><td>{index+1}</td><td><b>{itemName(item)}</b><small>{item?.description || ""}</small></td><td>{t(item?.hsnSacCode)}</td><td>{formatNumber(item?.calculation?.quantity,0,2)}</td><td>{displayCurrency(item?.calculation?.rate)}</td><td>{formatNumber(item?.taxPercentage,0,2)}%</td><td><b>{displayCurrency(item?.calculation?.totalAmount)}</b></td></tr>)}</tbody>
    </table>
    <footer><div><small>AMOUNT IN WORDS</small><b>Indian Rupees {numberToWords(grandTotal)} Only</b></div><div className="invoice-compact__totals"><span>Taxable <b>{displayCurrency(totals?.taxableAmount || 0)}</b></span><span>Total <b>{displayCurrency(grandTotal)}</b></span><span>Paid <b>{displayCurrency(paidAmount)}</b></span><span>Balance <b>{displayCurrency(balanceAmount)}</b></span></div></footer>
    <InvoiceSignature businessSnapshot={businessSnapshot} />
  </section>
);

export default CompactInvoiceTemplate;
